import { Card, IconButton, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Spinner from '../../components/common/spinner';
import { mainColor } from '../../constants';
import ContentPasteTwoToneIcon from '@mui/icons-material/ContentPasteTwoTone';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import DeleteIcon from '@mui/icons-material/Delete';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { getDocById, updateItem } from '../../utils/firebase/dynamic';
import { generateCode } from './utils';
import GirlImg from '../../assets/girlCode.png';
import './index.css'
import AnalysisSection from './AnalysisSection';
const HomePage = () => {
  const [show,setShow]=useState(false);
  const [rmvLoad,setrmvload]=useState(false);
  const [rstLoad,setRstload]=useState(false);
  const [code,setCode]=useState("Empty, click reset to create one");
  const [copied,setCopied]=useState(false);
  const [mainErr,setMainErr]=useState(false);
  const [loadErr,setError]=useState("")
  useEffect(()=>{
    (async()=>await getCode())()
  },[]);
  const getCode=async()=>{
    const {data,error}=await getDocById("stores","expertmin_admin");
    if(error) return setError(error);
    setCode(data.registrationCode);
  }
  const updateCode=async(data)=>{
    setError("")
    const updated=await updateItem(
      "stores",
      "expertmin_admin",
      {registrationCode:data})

      if(updated) { 
        setCode(data)
        return setError('')
      }
      if(!updated) return setError("Something went wrong")
  }
  const removeCode=async()=>{
    setrmvload(true);
    await updateCode(null);
    setrmvload(false)
  }
  const resetCode=async()=>{
    setRstload(true);
    const data=generateCode()
    await updateCode(data);
    setRstload(false)
  }
  return (
    <div style={{
      display:"flex",
      justifyContent:"center",
      flexDirection:"column",
      alignItems:"center",
      // height:"100vh",
      width:"100%",
      
      marginTop:30
    }}>
      <div style={{
          width:"90%",
          display:"flex",
          alignItems:"center",
          justifyContent:"space-between",
          margin:"10px 0px"
      }}>
        <Typography variant="h6" style={{ fontSize: 30 }}>Your Expert Minute Dashboard</Typography>

      </div>
      
        <Card sx={{width:"90%",height:"fit-content",marginTop:"20px"}} title="Team Code">
          {/* <Card.Section> */}
          
            <div style={{display:"flex",margin:20,justifyContent:"space-between"}}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom:20,
                }}
              >
                <div style={{
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"space-between",
                  margin:"10px 0px"
              }}>
                  <Typography variant="h6" style={{fontSize:30}}>Team Code</Typography>
                  
              </div>
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: 15,
                    color: "gray",
                  }}
                >
                  Share this code with other admins. Everyone is required to enter this code on their individual app's registration page.
                </p>
                <div
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                >
                  {show ? (
                    <div style={{
                      width:"100%",
                      borderRadius:5,
                      display:"flex",
                      // alignItems:"center",
                      flexDirection:"column",
                      padding:5,
                      color:'#000000',
                    }}>
                      <p
                        style={{
                          fontSize: 24,
                          // fontWeight:"600",
                          lineBreak: 4,
                        }}
                      >
                        {code||"Empty, click reset to create one"}
                      </p>
                        <p style={{
                          marginTop:10,
                          display:"block",
                          color:"red",
                          fontSize:14
                        }}>{loadErr}</p>
                    </div>
                  ) : (
                    <button
                      style={{
                        backgroundColor: "#3980FD",
                        border: 0,
                        width: 150,
                        height: 30,
                        borderRadius: 5,
                        color: "white",
                        cursor: loadErr?"default":"pointer",
                        opacity:loadErr&&".5"
                      }}
                      disabled={loadErr}
                      onClick={() => setShow(true)}
                    >
                      View code
                    </button>
                  )}
                </div>

                {show && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginTop: 10,
                      marginBottom: 5,
                    }}
                  >
                    <div
                      onClick={() => {
                        if (!rstLoad) resetCode();
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: 15,
                        alignItems: "center",
                      }}
                    >
                      {rstLoad ? (
                        <Spinner
                          color={mainColor}
                        />
                      ) : (
                        <IconButton sx={{cursor:"default"}}>
                          <RestartAltIcon />
                        </IconButton>
                        
                      )}
                      <p
                        style={{
                          cursor: "pointer",
                          marginLeft: 1,
                          fontSize: 14,
                        }}
                      >
                        Reset
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: 15,
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {rmvLoad ? (
                        <Spinner
                          accessibilityLabel="Spinner example"
                          size="small"
                        />
                      ) : (
                        <IconButton sx={{cursor:"default"}}>
                          <DeleteIcon/>
                        </IconButton>
                        // <FontAwesomeIcon
                        //   color="red"
                        //   size="lg"
                        //   icon={faTrashCan}
                        // />
                      )}
                      <p
                        onClick={() => {
                          if (!rmvLoad) removeCode();
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: 2,
                          fontSize: 14,
                        }}
                      >
                        Remove
                      </p>
                    </div>
                    <div
                      onClick={() => {
                        navigator.clipboard.writeText(code);
                        setCopied(true);
                        setTimeout(() => {
                          setCopied(false);
                        }, 1000);
                      }}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginRight: 15,
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {/* <FontAwesomeIcon
                        color="gray"
                        size="lg"
                        icon={copied ? faClipboard2 : faClipboard}
                      /> */}
                      <IconButton>
                          {!copied?<ContentPasteIcon/>:<ContentPasteTwoToneIcon/>}
                        </IconButton>
                      <p
                        style={{
                          cursor: "pointer",
                          marginLeft: 8,
                          fontSize: 14,
                        }}
                      >
                        {copied ? "Copied" : "Copy"}
                      </p>
                    </div>
                  </div>
                )}
                <p
                  style={{
                    marginTop: 10,
                    fontWeight: "400",
                    fontSize: 15,
                  }}
                >
                  Note:{" "}
                  <span style={{ color: "gray" }}>
                    if you deleted code you and other admin lose advantage of access app with store code.
                  </span>
                </p>
              </div>
              <div className="home-img" >
                <img src={GirlImg} width={"100%"} height={"100%"} />
              </div>
            </div>
          {/* </Card.Section> */}

        </Card>
        <AnalysisSection/>
    </div>
  )
}

export default HomePage